export default __webpack_public_path__ + "static/media/java.a6c04d79.png";